import ExperimentUtils from 'utils/experiment';
import {
    USER_LOGIN,
    USER_LOGOUT,
    USER_UPDATE,
} from 'user/user-actions';
import {SEARCH_REQUEST_SET_TERM} from 'search-request/search-request-actions';
import {SPOT_SET_TERM} from 'spot/spot-actions';

const MW_RENO_CHECKOUT = 'mw_reno_checkout';

export const experimentMiddleware = store => next => action => {
    const {
        type,
        payload,
    } = action;

    switch (type) {
        case USER_UPDATE:
        case `${USER_LOGIN}_FULFILLED`: {
            const {
                email,
                isAdmin,
            } = payload;

            ExperimentUtils.setUserAttributes({
                email,
                staff: Boolean(isAdmin).toString(),
            });

            const isMobileRenoCheckoutEnabled = ExperimentUtils.isFeatureEnabled(MW_RENO_CHECKOUT);

            payload.isCheckoutCTAs = isMobileRenoCheckoutEnabled && ExperimentUtils.getFeatureVariableBoolean({
                featureName: MW_RENO_CHECKOUT,
                variableName: 'checkout_ctas',
            });
            payload.isCheckoutHeadersFooters = isMobileRenoCheckoutEnabled && ExperimentUtils.getFeatureVariableBoolean({
                featureName: MW_RENO_CHECKOUT,
                variableName: 'headers_footers',
            });
            payload.isCheckoutSecurePayment = isMobileRenoCheckoutEnabled && ExperimentUtils.getFeatureVariableBoolean({
                featureName: MW_RENO_CHECKOUT,
                variableName: 'secure_payment',
            });
            payload.isCheckoutValueProps = isMobileRenoCheckoutEnabled && ExperimentUtils.getFeatureVariableBoolean({
                featureName: MW_RENO_CHECKOUT,
                variableName: 'checkout_value_props',
            });
            payload.isCollapsedSummary = ExperimentUtils.getVariation({
                experiment: 'collapsed_summary'
            }) === 'collapsed_summary';
            payload.isEventsModalDisabled = ExperimentUtils.getVariation({
                experiment: 'events_modal_cvr_effect'
            }) === 'no_modal';

            break;
        }

        case `${USER_LOGOUT}_FULFILLED`: {
            ExperimentUtils.initUserAttributes();

            break;
        }

        case SEARCH_REQUEST_SET_TERM:
        case SPOT_SET_TERM: {
            const {
                monthly,
            } = payload;

            ExperimentUtils.setUserAttributes({
                monthly: Boolean(monthly).toString(),
            });

            break;
        }
    }

    return next(action);
};
